import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3.5">
        <li className="h-6 w-24 bg-background/10 animate-pulse" />
        <li className="h-6 w-20 bg-background/10 animate-pulse" />
        <li className="h-6 w-28 bg-background/10 animate-pulse" />
        <li className="h-6 w-24 bg-background/10 animate-pulse" />
      </ul>;
  }
  return <ul className="flex flex-col gap-3.5">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default text-base md:text-lg font-semibold text-background tracking-tight inline-block border-b-2 border-transparent hover:border-background hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const readLinks = [{
    label: "New Homes",
    href: "/HomePage"
  }, {
    label: "Investment",
    href: "/HomePage"
  }, {
    label: "Lot Solutions",
    href: "/HomePage"
  }, {
    label: "Process",
    href: "/HomePage"
  }];
  const followLinks = [{
    label: "LinkedIn",
    href: "#"
  }, {
    label: "Houzz",
    href: "#"
  }, {
    label: "Instagram",
    href: "#"
  }];
  return <section data-section-id="9716" id="footer" className="bg-foreground text-background border-t-2 border-background py-24 md:py-32 light">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-14 md:gap-x-6">
          {}
          <div className="md:col-span-12 lg:col-span-4">
            <Link to="/" className="inline-block">
              <span className="font-default text-[2rem] leading-none font-extrabold text-background tracking-tight" style={{
              letterSpacing: "-0.035em"
            }}>
                Acumen<em className="not-italic">D&B</em>
              </span>
            </Link>
            <p className="mt-6 font-default text-base md:text-lg leading-relaxed text-background/70 max-w-[32ch]" style={{
            letterSpacing: "-0.005em"
          }}>
              Knoxville-based residential architecture firm specializing in contemporary design and efficient, permit-ready solutions.
            </p>
          </div>

          {}
          <div className="md:col-span-6 lg:col-span-3">
            <h3 className="font-default text-xs font-semibold text-background/60 uppercase tracking-[0.12em] mb-6">
              Navigation
            </h3>
            <MenuProvider menu_id="footer_menu">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-6 lg:col-span-3">
            <h3 className="font-default text-xs font-semibold text-background/60 uppercase tracking-[0.12em] mb-6">
              Services
            </h3>
            <ul className="flex flex-col gap-3.5">
              {readLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="font-default text-base md:text-lg font-semibold text-background tracking-tight inline-block border-b-2 border-transparent hover:border-background hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-12 lg:col-span-2">
            <h3 className="font-default text-xs font-semibold text-background/60 uppercase tracking-[0.12em] mb-6">
              Connect
            </h3>
            <ul className="flex flex-col gap-3.5">
              {followLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} newTab className="font-default text-base md:text-lg font-semibold text-background tracking-tight inline-block border-b-2 border-transparent hover:border-background hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-16 border-t-2 border-background" />

        {}
        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-default text-xs font-medium text-background/60 tracking-wider">
            © {new Date().getFullYear()} Acumen D&B. All rights reserved.
          </p>
          <p className="font-default text-xs font-medium text-background/60 tracking-wider">
            Modern Residential Architecture in Knoxville, TN
          </p>
        </div>
      </div>
    </section>;
}